import {
  getFromSessionStorage,
  setToSessionStorage,
  parseQueryString,
  clearEmptyDeep,
} from './util';
import {
  BingKeyWord,
  BingMsclkid,
  BingMsclkidCreationTime,
  BingQuery,
  GoogleGclid,
  GoogleGclidCreationTime,
  GoogleKeyword,
  GoogleMatchType,
} from '@common/config';

/**
 * 创建获取时间
 * @param {*} obj
 * @param {*} key
 * @param {*} saveKey
 */
const handleCreateTime = (obj, key, saveKey) => {
  const oldValue = getFromSessionStorage(saveKey);
  if (
    (key === 'gclid_creationTime' &&
      obj?.['gclid']?.length &&
      !oldValue?.length) ||
    (key === 'msclkid_creationTime' &&
      obj?.['msclkid']?.length &&
      !oldValue?.length)
  ) {
    setToSessionStorage(saveKey, Date.now());
  }
};

/**
 * 参数保存Session处理
 * @param {*} keyMap
 */
export const updateParamsToSession = keyMap => {
  const obj = parseQueryString(window.location.search);
  Object.keys(keyMap)?.forEach(key => {
    handleCreateTime(obj, key, keyMap[key]);
    const value = obj?.[key];
    const oldValue = getFromSessionStorage(keyMap?.[key]);
    if (value || oldValue) {
      setToSessionStorage(keyMap?.[key], value || oldValue);
    }
  });
};

/**
 * 更新bing广告参数
 */
export const updateBingParams = () => {
  updateParamsToSession({
    msclkid: BingMsclkid,
    msclkid_creationTime: BingMsclkidCreationTime,
    bingkeyword: BingKeyWord,
    bingquery: BingQuery,
  });
};

/**
 * 更新google广告参数
 */
export const updateGoogleParams = () => {
  updateParamsToSession({
    gclid: GoogleGclid,
    gclid_creationTime: GoogleGclidCreationTime,
    ggkeyword: GoogleKeyword,
    ggmatchtype: GoogleMatchType,
  });
};

/**
 * 广告参数处理
 */
export const initAdsParams = () => {
  updateBingParams();
  updateGoogleParams();
};

/**
 * 获取adsExtend 对象
 * @returns
 */
export const getAdsExtend = () => {
  const adsMap = {
    gclid: GoogleGclid,
    gtime: GoogleGclidCreationTime,
    gkeyword: GoogleKeyword,
    gtype: GoogleMatchType,
    msclkid: BingMsclkid,
    btime: BingMsclkidCreationTime,
    bkeyword: BingKeyWord,
    bquery: BingQuery,
  };
  Object.keys(adsMap)?.forEach(key => {
    adsMap[key] = getFromSessionStorage(adsMap[key]);
  });
  const adsExtend = {
    google: {
      gclid: {
        value: adsMap['gclid'],
        creationTime: adsMap['gtime'],
      },
      ggkeyword: {
        keyword: adsMap['gkeyword'],
        ggmatchtype: adsMap['gtype'],
      },
    },
    bing: {
      msclkid: {
        value: adsMap['msclkid'],
        creationTime: adsMap['btime'],
      },
      bingkeyword: {
        keyword: adsMap['bkeyword'],
        bingquery: adsMap['bquery'],
      },
    },
  };
  clearEmptyDeep(adsExtend);
  return adsExtend;
};

/**
 * 获取adsExtend 字符串 urlencode
 * @returns
 */
export const getAdsExtendStr = () => {
  return encodeURIComponent(JSON.stringify(getAdsExtend()));
};
